// TODO enable eslint
/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
import React, { Component } from "react"
import mapValues from "lodash/mapValues"
import set from "lodash/set"
import reduce from "lodash/reduce"
import isArray from "lodash/isArray"
import { SubmissionError } from "redux-form"

/*
** Plugin for model/entity hoc

Takes an RequestError with status 400 and convert it to the SubmissionError with
invalid fields details.
*/

function getFirstValue(value) {
  return isArray(value) ? value[0] : value
}

export default () => ({
  connect: BaseComponent =>
    class TransformToSubmissionError extends Component {
      // eslint-disable-next-line camelcase
      UNSAFE_componentWillReceiveProps(nextProps) {
        if (
          this.originError !== nextProps[nextProps.to].error &&
          nextProps[nextProps.to].error !== this.computedError
        ) {
          this.computedError = nextProps[nextProps.to].error
          const { error } = nextProps[nextProps.to]
          if (error && error.response && error.response.status === 400) {
            if (
              error.data.errorCode === `application.request.validation.failed`
            ) {
              const invalidFields = mapValues(error.data.body, getFirstValue)
              /* Here we parse invalid fields to Object for ReduxForm
            (at the moment, this work only for object-type-fields
            like `fields.name` with all nesting) */
              const parsedFields = reduce(
                invalidFields,
                (acc, value, key) => {
                  set(acc, key, value)
                  return acc
                },
                {},
              )
              this.originError = error
              this.computedError = new SubmissionError({
                ...parsedFields,
                _error: error.data.exception || `Unknown error`,
              })
            }
          }
        }
        /* You may ask - why is mutable. React props system is not perfect and
         * there is no solution to extend nested object without surplus object
         * spread. Thus for props, which has no immutability as difference
         * point we can safely mutate properties, if we care by ourself
         * about comparing old error and next error. In turn, for subsequent
         * elements, this property will look like original */
        nextProps[nextProps.to].error = this.computedError
      }

      computedError = this.props[this.props.to].error

      render() {
        return <BaseComponent {...this.props} />
      }
    },
})
